module.exports = __webpack_public_path__ + "static/media/tableau.11af82af.png";